import React from 'react';
import LegalPage, { H2, P, A } from './LegalPage';

const Terms = () => (
  <LegalPage title="Terms &amp; Conditions" updated="June 13, 2026">
    <P>
      These Terms &amp; Conditions (“Terms”) govern your access to and use of the Influencer.in platform
      and services. By accessing or using Influencer.in, you agree to be bound by these Terms.
    </P>

    <H2>Use of the Service</H2>
    <P>
      You agree to use the platform only for lawful purposes and in accordance with these Terms. You are
      responsible for maintaining the confidentiality of your account credentials and for all activity
      under your account.
    </P>

    <H2>YouTube API Services</H2>
    <P>
      Influencer.in uses YouTube API Services. By accessing any feature that connects to YouTube or
      retrieves YouTube data, you agree to be bound by the{' '}
      <A href="https://www.youtube.com/t/terms">YouTube Terms of Service</A>, and you acknowledge that
      Google’s use of your information is governed by the{' '}
      <A href="https://policies.google.com/privacy">Google Privacy Policy</A>. You may revoke
      Influencer.in’s access to your Google/YouTube data at any time via{' '}
      <A href="https://myaccount.google.com/permissions">https://myaccount.google.com/permissions</A>.
    </P>

    <H2>Intellectual Property</H2>
    <P>
      All content, trademarks, and materials on the platform are owned by Influencer.in or its licensors
      and are protected by applicable laws. You may not copy, modify, or distribute them without
      authorization.
    </P>

    <H2>Data &amp; Privacy</H2>
    <P>
      Your use of the platform is also governed by our{' '}
      <a href="/privacy-policy" style={{ color: '#232f63', fontWeight: 600 }}>
        Privacy Policy
      </a>
      , which explains how we collect, use, and protect your information, including data accessed through
      YouTube API Services.
    </P>

    <H2>Disclaimers &amp; Limitation of Liability</H2>
    <P>
      The platform is provided “as is” without warranties of any kind. To the maximum extent permitted by
      law, Influencer.in is not liable for any indirect, incidental, or consequential damages arising from
      your use of the service.
    </P>

    <H2>Changes to These Terms</H2>
    <P>
      We may update these Terms from time to time. Continued use of the platform after changes take effect
      constitutes acceptance of the revised Terms.
    </P>

    <H2>Contact Us</H2>
    <P>
      For any questions about these Terms, contact us at{' '}
      <A href="mailto:enquiry@influencer.in">enquiry@influencer.in</A>.
    </P>
  </LegalPage>
);

export default Terms;
